export const LISTING_STATUSES = {
  ACTIVATED: {
    message: {
      id: 'pause.status.active',
      defaultMessage: 'Active'
    },
    color: 'green'
  },
  PENDING: {
    message: {
      id: 'pause.status.pending_approval',
      defaultMessage: 'Pending approval'
    },
    color: 'yellow'
  },
  IN_REVIEW: {
    message: {
      id: 'pause.status.pending_approval',
      defaultMessage: 'Pending approval'
    },
    color: 'yellow'
  },
  DEACTIVATED: {
    message: {
      id: 'pause.status.deactivated',
      defaultMessage: 'Deactivated'
    },
    color: 'red'
  },
  HOST_DELETED: {
    message: {
      id: 'pause.status.deactivated',
      defaultMessage: 'Deactivated'
    },
    color: 'red'
  },
  DRAFT: {
    message: {
      id: 'pause.status.deactivated_by',
      defaultMessage: 'Deactivated by Peerspace'
    },
    color: 'red'
  },
  PAUSED: {
    message: {
      id: 'pause.status.paused',
      defaultMessage: 'Paused'
    },
    color: 'blue'
  },
  PAUSED_INTERNALLY: {
    message: {
      id: 'pause.status.paused_by',
      defaultMessage: 'Paused by Peerspace'
    },
    color: 'yellow'
  }
};
